<template>
    <div
        v-if="car.damages?.length"
        class="car-damages"
    >
        <div
            v-for="(damage, index) in car.damages ?? []"
            :key="index"
            class="car-damage"
        >
            <div class="car-damage__info">
                <div class="car-damage__title">Повреждение {{ index + 1 }}</div>

                <div class="car-damage__list">
                    <div class="car-damage__element">
                        <div class="car-damage__label">Элемент:</div>
                        <div class="car-damage__value">
                            {{ getCarDamageElementLabel(damage.element) }}
                        </div>
                    </div>

                    <div class="car-damage__element">
                        <div class="car-damage__label">Тип повреждения:</div>
                        <div class="car-damage__value">
                            {{ getCarDamageTypeLabel(damage.type) }}
                        </div>
                    </div>

                    <div v-if="damage.paintwork_thickness" class="car-damage__element">
                        <div class="car-damage__label">Толщина ЛКП:</div>
                        <div class="car-damage__value">{{ damage.paintwork_thickness }} мкм</div>
                    </div>

                    <div v-if="damage.comment" class="car-damage__element">
                        <div class="car-damage__label">Комментарий:</div>
                        <div class="car-damage__value">{{ damage.comment }}</div>
                    </div>
                </div>
            </div>

            <img
                :src="damage.photo?.path_small ?? damage.photo?.path ?? noPhotoImage"
                class="car-damage__image"
                @click="openGallery(index)"
            />
        </div>
    </div>
    <div v-else>
        нет данных
    </div>
</template>

<script setup lang="ts">
    import noPhotoImage from '@/assets/images/cars/no-photo.webp';

    import { onMounted, ref, watch } from 'vue';

    import lightGallery from 'lightgallery';

    import { Car, CarDamage, getCarDamageElementLabel, getCarDamageTypeLabel } from '@/types/car.type.ts';

    const { car } = defineProps<{
        car: Car,
    }>();

    const galleryRef = ref<ReturnType<typeof lightGallery> | null>(null);

    watch(
        () => car.damages,
        () => initGallery(),
        { deep: true },
    );

    function openGallery(index: number): void {
        if (galleryRef.value) {
            galleryRef.value.openGallery(index);
        }
    }

    function initGallery(): void {
        if (galleryRef.value !== null) {
            galleryRef.value.destroy();
        }

        galleryRef.value = lightGallery(
            document.querySelector('.ui-gallery') as HTMLElement,
            {
                dynamic: true,
                dynamicEl: car.damages?.map((damage: CarDamage) => ({
                    src: damage.photo?.path,
                    thumb: damage.photo?.path_small ?? damage.photo?.path,
                })),
            },
        );
    }

    onMounted(() => {
        initGallery();
    });
</script>

<style scoped lang="scss">
    @use './CarDamage.scss' as *;
</style>
